import { Dispatch, SetStateAction, MouseEvent } from "react";
import { ReactComponent as GridIcon } from '../../assets/Icons/adornments/Grid.svg';
import { ReactComponent as ListIcon } from '../../assets/Icons/adornments/Table.svg';

export default function ListGridToggle({ 
    isGrid,
    setIsGrid,
 }: {
    isGrid: boolean,
    setIsGrid: Dispatch<SetStateAction<boolean>>,
 }) {
    return (
        <div className="flex justify-start items-center gap-3">
            <button 
                onClick={(e:MouseEvent<HTMLButtonElement>) => {e.preventDefault(); setIsGrid(false)}} 
                className={`w-[24px] h-[24px] transition-all ${isGrid ? 'text-outline hover:text-disable' : 'text-primary hover:text-primary'}`}
            >
                <ListIcon/>
            </button>
            <button 
                onClick={(e:MouseEvent<HTMLButtonElement>) => {e.preventDefault(); setIsGrid(true)}} 
                className={`w-[20px] h-[20px] transition-all ${!isGrid ? 'text-outline hover:text-disable' : 'text-primary hover:text-primary'}`}
            >
                <GridIcon/>
            </button>
        </div>
    )
}